import { createAuthClient } from 'better-auth/react';
import { emailOTPClient, inferAdditionalFields } from 'better-auth/client/plugins';
import type { Auth } from './auth.server';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/remix';

export const authClient = createAuthClient({
  plugins: [inferAdditionalFields<Auth>(), emailOTPClient()],

  fetchOptions: {
    onError: async (context) => {
      const { response, error } = context;

      if (response.status === 429) {
        const retryAfter = response.headers.get('X-Retry-After');

        toast.error(`Rate limit exceeded. Retry after ${retryAfter} seconds`);

        Sentry.captureException(error, {
          extra: {
            message: 'Rate limit exceeded',
            retryAfter,
          },
        });
      }
    },
  },
});

export const googleSignIn = async () => {
  console.log('[newa] sign in function called');

  const { data, error } = await authClient.signIn.social({
    provider: 'google',
  });

  console.log('[newa] sign in function called', data, error);

  if (error) {
    toast.error('Error signing in with Google');
    Sentry.captureException(error, {
      extra: {
        provider: 'google',
      },
    });

    throw new Error(error.statusText || 'Error signing in');
  }
};

export const sendOtpRequest = async (email: string) => {
  const { data, error } = await authClient.emailOtp.sendVerificationOtp({
    email,
    type: 'sign-in',
  });

  console.log('[newa] better-auth send otp function called: ', data, error);

  if (error) {
    Sentry.captureException(error, {
      extra: {
        message: 'Error sending OTP',
        email,
      },
    });
  }

  return { data, error };
};

// only works if the user first exists
// export const verifyOtpRequest = async (email: string, otp: string) => {
//   const { data, error } = await authClient.emailOtp.checkVerificationOtp({
//     email,
//     type: 'sign-in',
//     otp,
//   });

//   console.log('[newa] better-auth verify otp function called: ', data, error);

//   return { data, error };
// };

export const otpSignIn = async (email: string, otp: string) => {
  const { data, error } = await authClient.signIn.emailOtp({
    email,
    otp,
  });

  console.log('[newa] better-auth sign in with otp function called: ', data, error);

  if (error) {
    Sentry.captureException(error, {
      extra: {
        message: 'Error signing in with OTP',
        email,
      },
    });
  }

  return { data, error };
};

export const signOut = async () => {
  const { data, error } = await authClient.signOut();

  console.log('[newa] better-auth sign out function called: ', data, error);

  if (error) {
    Sentry.captureException(error, {
      extra: {
        message: 'Error signing out',
      },
    });
  }

  return { data, error };
};

export type Session = typeof authClient.$Infer.Session;
